import Resources from "shared/actions/resourcesActions";

export class ReferencesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "references", `/api/v1/references`);
  }
}

export default ReferencesResource;
